import { observer } from 'mobx-react';

type ModalLoadingProps = {
  options: any;
};

const ModalLoading = ({ options }: ModalLoadingProps) => {
  return (
    <div className="modal-loading">
      <div className="loading-icon" />
      <pre>{options.msg || '로딩중입니다.'}</pre>
    </div>
  );
};

export default observer(ModalLoading);
